import { render, staticRenderFns } from "./ComparisonProducts.vue?vue&type=template&id=ebb61fbe&"
import script from "./ComparisonProducts.vue?vue&type=script&lang=js&"
export * from "./ComparisonProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports